
import React from "react";
import { Link } from "react-router-dom";
import { NavItem, NavLink, Badge, Collapse, DropdownItem } from "shards-react";

export default class HelpCenter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };

        this.toggleHelpCenter = this.toggleHelpCenter.bind(this);
    }

    toggleHelpCenter() {
        this.setState({
            visible: !this.state.visible
        });
    }

    setMenuVisible(newState) {
        this.setState({
            visible: newState
        });
    }

    render() {
        return (
            <NavItem className="border-right dropdown notifications" >
                <NavLink
                className="nav-link-icon text-center"
                onClick={this.toggleHelpCenter}
                >
                    <div className="nav-link-icon__wrapper cursor-pointer">
                        <i className="material-icons" style={{ "color": "var(--color-gray-5)"}}>help</i>
                    </div>
                </NavLink>
                <Collapse onMouseLeave={() => this.setMenuVisible(false)} open={this.state.visible} className="dropdown-menu dropdown-menu-small">
                    <Link to="/helpcenter/get-started">
                        <DropdownItem>
                            {/* <div className="notification__icon-wrapper">
                                <div className="notification__icon">
                                    <i className="material-icons">fiber_new</i>
                                </div>
                            </div> */}
                            <div className="notification__content">
                                <span className="notification__category">Get Started</span>
                                {/* <p> A very warm <span className="text-success text-semibold">welcome</span> to you! It is lovely to have you among us! {" "} </p> */}
                            </div>
                            
                        </DropdownItem>
                    </Link>
                    <Link to="/helpcenter/filter-parameters-guide">
                        <DropdownItem>
                            <div className="notification__content">
                                <span className="notification__category">Filter Parameters Guide</span>
                            </div>
                        </DropdownItem>
                    </Link>
                    <Link to="/helpcenter/faq">
                        <DropdownItem>
                            <div className="notification__content">
                                <span className="notification__category">FAQ</span>
                            </div>
                        </DropdownItem>
                    </Link>
                    {/* <DropdownItem className="notification__all text-center">
                        View all HelpCenter
                    </DropdownItem> */}
                </Collapse>
            </NavItem>
        );
    }
}